document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-custom-popup]");

  if (!trigger) return;

  event.preventDefault();

  const popupId = trigger.dataset.customPopup;
  const popup = document.getElementById(popupId);

  if (popup && typeof popup.show === "function") {
    popup.show();
  }
});

const buttons = document.querySelectorAll(".custom-section-filter .filter-btn");
const items = document.querySelectorAll(".custom-filter-item.section");
const filterSection = document.querySelector("#shopify-section-template--22329096437974__rich_text_WCKDUE");

buttons.forEach(button => {
    button.addEventListener("click", () => {

        // Active button
        buttons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");

        const filter = button.dataset.filter;

        items.forEach(item => {

            if (filter === "all") {
                item.classList.remove("hide");
                return;
            }

            if (item.classList.contains(filter)) {
                item.classList.remove("hide");
            } else {
                item.classList.add("hide");
            }

        });

        filterSection.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });

    });
});

const cards = document.querySelectorAll('.js-flip-card');

if (window.matchMedia('(hover: none)').matches) {

  cards.forEach(card => {
      card.addEventListener('click', function (e) {
      e.stopPropagation();

      cards.forEach(item => {
          if (item !== card) {
          item.classList.remove('is-flipped');
          }
      });

      card.classList.toggle('is-flipped');
      });
  });

  ['click', 'touchstart'].forEach(eventType => {
      document.addEventListener(eventType, function (e) {
      if (!e.target.closest('.shopify-section--custom-premium-licensor-showcase .js-flip-card')) {
          cards.forEach(card => card.classList.remove('is-flipped'));
      }
      }, { passive: true });
  });

}


/*
 * Impact theme - Buy it now in a new tab
 *
 * Shopify's native accelerated checkout button is rendered inside a closed
 * Shadow DOM, so its internal button cannot reliably be given target="_blank".
 * This custom Buy it now button uses Shopify's documented cart permalink
 * format to send the selected variant directly to checkout in a new tab.
 */
(() => {
  const BUY_NOW_SELECTOR = '.buy-now-new-tab button';

  function base64UrlEncode(value) {
    const bytes = new TextEncoder().encode(value);
    let binary = '';

    bytes.forEach((byte) => {
      binary += String.fromCharCode(byte);
    });

    return btoa(binary);
  }

  function getBuyNowUrl(form) {
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantityValue = formData.get('quantity');
    const quantity = Math.max(1, parseInt(quantityValue || '1', 10));

    if (!variantId) {
      throw new Error('Buy it now: no variant ID was found in the product form.');
    }

    // Shopify cart permalinks support line-item properties for the first item.
    const properties = {};

    for (const [name, value] of formData.entries()) {
      if (!name.startsWith('properties[') || !name.endsWith(']')) continue;
      if (typeof value !== 'string' || value === '') continue;

      const propertyName = name.slice(11, -1);
      properties[propertyName] = value;
    }

    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(
      `${root}cart/${encodeURIComponent(variantId)}:${quantity}`,
      window.location.origin
    );

    if (Object.keys(properties).length > 0) {
      url.searchParams.set('properties', base64UrlEncode(JSON.stringify(properties)));
    }

    return url.toString();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(BUY_NOW_SELECTOR);
    if (!button) return;

    const buyButtons = button.closest('buy-buttons');
    const formId = buyButtons?.getAttribute('form');
    const form = formId ? document.forms[formId] : button.closest('form');

    if (!form) {
      console.error('Buy it now: product form could not be found.');
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    try {
      const checkoutUrl = getBuyNowUrl(form);
      window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      console.error(error);
    }
  });
})();
